export interface SupplierStatusConfig {
  label: string
  color: string
  bgColor: string
}

const STATUS_MAP: Record<string, SupplierStatusConfig> = {
  pre_registered:  { label: 'Preregistro',  color: 'text-gray-600',  bgColor: 'bg-white border border-gray-300' },
  sent_to_review:  { label: 'En Revisión',  color: 'text-blue-700',  bgColor: 'bg-blue-100'  },
  pending:         { label: 'Pendiente',     color: 'text-yellow-700',bgColor: 'bg-yellow-100'},
  approved:        { label: 'Aprobado',      color: 'text-green-700', bgColor: 'bg-green-100' },
  rejected:        { label: 'Rechazado',     color: 'text-red-700',   bgColor: 'bg-red-100'   },
  active:          { label: 'Activo',        color: 'text-green-700', bgColor: 'bg-green-100' },
  inactive:        { label: 'Inactivo',      color: 'text-gray-700',  bgColor: 'bg-gray-100'  },
}

const FALLBACK: SupplierStatusConfig = { label: '', color: 'text-gray-700', bgColor: 'bg-gray-100' }

export const getSupplierStatusConfig = (status: string): SupplierStatusConfig => {
  const config = STATUS_MAP[status] ?? { ...FALLBACK, label: status }
  return config
}
